import { h, Host } from "@stencil/core";
export class DnnToggle {
    constructor() {
        /** If 'true' the toggle is checked (on). */
        this.checked = false;
        /** If 'true' the toggle is not be interacted with. */
        this.disabled = false;
        /** The value to post when used in forms. */
        this.value = "on";
        this.focused = false;
    }
    handleClick() {
        this.checked = !this.checked;
    }
    checkedChanged(newValue) {
        this.checkChanged.emit({ checked: newValue });
        this.setFormValue();
    }
    componentWillLoad() {
        this.originalChecked = this.checked;
        this.setFormValue();
    }
    formResetCallback() {
        this.internals.setValidity({});
        this.checked = this.originalChecked;
    }
    setFormValue() {
        if (this.name != undefined && this.name.length > 0) {
            if (this.checked) {
                var data = new FormData();
                data.append(this.name, this.value);
                this.internals.setFormValue(data);
            }
            else {
                this.internals.setFormValue("");
            }
        }
    }
    render() {
        return (h(Host, { key: '68688e18b35345aa37170a1b92b9d974c1524a77', tabIndex: this.focused ? -1 : 0, onFocus: () => this.button.focus(), onBlur: () => this.button.blur() }, h("button", { key: '921cfb95fc6edfb37dc2be753b7b837a52696f26', ref: el => this.button = el, disabled: this.disabled, class: { 'checked': this.checked }, onFocus: () => this.focused = true, onBlur: () => this.focused = false }, h("div", { key: '2abf8cdb0187d35415a58d5329a04d877632b5a8', class: "handle" }))));
    }
    static get is() { return "dnn-toggle"; }
    static get encapsulation() { return "shadow"; }
    static get formAssociated() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-toggle.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-toggle.css"]
        };
    }
    static get properties() {
        return {
            "checked": {
                "type": "boolean",
                "attribute": "checked",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If 'true' the toggle is checked (on)."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "attribute": "disabled",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If 'true' the toggle is not be interacted with."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "name": {
                "type": "string",
                "attribute": "name",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The field name to use in forms."
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "value": {
                "type": "string",
                "attribute": "value",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The value to post when used in forms."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"on\""
            }
        };
    }
    static get states() {
        return {
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "checkChanged",
                "name": "checkChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the toggle changed"
                },
                "complexType": {
                    "original": "DnnToggleChangeEventDetail",
                    "resolved": "DnnToggleChangeEventDetail",
                    "references": {
                        "DnnToggleChangeEventDetail": {
                            "location": "import",
                            "path": "./toggle-interface",
                            "id": "src/components/dnn-toggle/toggle-interface.ts::DnnToggleChangeEventDetail"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "checked",
                "methodName": "checkedChanged"
            }];
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "handleClick",
                "target": undefined,
                "capture": true,
                "passive": false
            }];
    }
    static get attachInternalsMemberName() { return "internals"; }
}
//# sourceMappingURL=dnn-toggle.js.map
